import { getReturnToPath } from '~/composables/auth-session'

export default defineNuxtPlugin(() => {
  const baseURL = useRuntimeConfig().app.baseURL
  const origFetch = window.fetch

  const isMySarvbanPage = () => {
    const path = window.location.pathname + window.location.search
    return getReturnToPath(path, baseURL).startsWith('/my-sarvban')
  }

  window.fetch = async (...args) => {
    const response = await origFetch(...args)
    if (!isMySarvbanPage() || (response.status !== 401 && response.status !== 403)) {
      return response
    }

    const auth = useAuth()
    const redirect = auth.handleSessionExpired({ response })
    if (redirect && typeof redirect.then === 'function') await redirect
    return response
  }
})
